export const applicationStartDate = "Mar 30, 2026 10:00:00";
export const applicationEndDate = "Apr 03, 2026 23:59:59";

export const getApplicationStatus = () => {
  const now = new Date().getTime();
  const startDate = new Date(applicationStartDate).getTime();
  const endDate = new Date(applicationEndDate).getTime();

  if (now < startDate) {
    return {
      canApply: false,
      text: "COMING SOON",
      comingSoon: true,
    };
  } else if (now >= startDate && now <= endDate) {
    return { canApply: true, text: "APPLY NOW" };
  } else {
    return { canApply: false, text: "CLOSED" };
  }
};

export const application = getApplicationStatus();
